export { default, type BadgeProps, type BadgeType } from './Badge';
